import {SvgIcon, useTheme} from '@mui/material';

export default function HandlingComplintsService(props: { color?: string; }) {
	const {color = null} = props;
	const theme = useTheme();
	// @ts-ignore
	const first = theme.palette.primary[400];
	// @ts-ignore
	const second = theme.palette.primary[600];
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path
				d="M9.89254 19.5934C10.3319 20.0327 11.0907 20.0327 11.5699 19.5934C11.7297 19.2739 13.9262 17.9559 12.7281 16.7578L7.77585 11.8055C7.2966 11.3662 6.57773 11.3662 6.09848 11.8055L4.94029 12.9637C4.50098 13.403 4.50098 14.1619 4.94029 14.6411L7.41642 17.1172L9.89254 19.5934ZM18.1596 11.3263C18.5989 11.7656 19.3577 11.7656 19.837 11.3263L20.9952 10.1681C21.4744 9.68885 21.4345 8.96997 20.9952 8.49072L16.0429 3.53847C15.6036 3.09916 14.8448 3.09916 14.3655 3.53847L13.2074 4.7366C12.768 5.17591 12.768 5.93472 13.2074 6.41397L18.1596 11.3263ZM17.5605 25.5041C17.7203 25.2645 17.8002 24.9849 17.8002 24.7054C17.8002 23.9466 17.2011 23.3076 16.4822 23.3076H6.57773C5.85885 23.3076 5.25979 23.9066 5.25979 24.7054C5.25979 25.0249 5.33967 25.3044 5.49942 25.5041C4.34123 25.9434 3.54248 27.0617 3.54248 28.3796C3.54248 28.5793 3.70223 28.779 3.94186 28.779H19.158C19.3577 28.779 19.5574 28.5793 19.5574 28.3796C19.5175 27.0617 18.7187 25.9434 17.5605 25.5041Z"
				fill={color || 'url(#paint0_linear_1440_2879)'}/>
			<path opacity="0.4"
			      d="M12.9922 15.9722C13.0321 15.9722 13.0321 16.0121 13.0321 16.0121L17.3454 11.6989L17.3054 11.6589L12.3532 6.70669C12.3132 6.70669 12.3132 6.66675 12.3132 6.66675L8 10.98L8.03994 11.0199L12.9922 15.9722ZM27.4496 22.9613L16.9859 13.2165L14.5497 15.6527L24.2945 26.1563C25.1332 27.0748 26.6109 27.1547 27.5294 26.1962C28.448 25.2776 28.4081 23.8399 27.4496 22.9613Z"
			      fill={color || 'url(#paint1_linear_1440_2879)'}/>
			<defs>
				<linearGradient id="paint0_linear_1440_2879" x1="20.96" y1="3.20899" x2="2.6644" y2="3.85351"
				                gradientUnits="userSpaceOnUse">
					<stop stopColor={first}/>
					<stop offset="1" stopColor={second}/>
				</linearGradient>
				<linearGradient id="paint1_linear_1440_2879" x1="27.7631" y1="6.66675" x2="7.03091" y2="7.71504"
				                gradientUnits="userSpaceOnUse">
					<stop stopColor={first}/>
					<stop offset="1" stopColor={second}/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
